export const MAIL_OUTBOX_PAGE_SIZE = 15;

export const MAIL_OUTBOX_PAGE_GUIDE = [
  "Filtrez par statut, modèle, document source, destinataire ou date.",
  "« Réessayer » n'apparaît que sur les envois en échec.",
];

export const MAIL_OUTBOX_PAGE_TIP =
  "Un réessai régénère le contenu depuis l'état actuel du document, pas depuis le contenu du premier envoi.";

export const MAIL_OUTBOX_PAGE_INTRO =
  "Historique complet des emails envoyés par l'application (factures, proformas, bons de livraison, rappels).";

export const MAIL_OUTBOX_EMPTY_MESSAGE = "Aucun email trouvé.";

export const MAIL_OUTBOX_STATUS_LABELS: Record<string, string> = {
  sent: "Envoyé",
  failed: "Échec",
  pending: "En attente",
};
